import React from 'react';
import { connect } from 'react-redux';
import { createUpdateTracking } from '../../redux/actions/Tracking/TrackingAction';
const AddTracking = ({customer,allProducts,createUpdateTracking}) => {
    const handleSubmit = () => {
        const data={
            'products':allProducts,
            'customer':customer,
            'status':'Ordered'
        };
        console.log('data',data);
        createUpdateTracking(0,data);
    };
    return (
        <div>
            <button onClick={handleSubmit}>Submit</button>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        trackings: state.trackings,
    };
};
const mapDispatchToProps={
    createUpdateTracking,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTracking);
